// extracted by mini-css-extract-plugin
module.exports = {"root":"CardGrid-m__root___5UsmT","cardGridItem":"CardGrid-m__cardGridItem___3-Kvr","big":"CardGrid-m__big___2KTZx","spinAround":"CardGrid-m__spinAround___23r5V"};